// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Fzcby","title":"Info_title__3xMJm","links":"Info_links__vHzEt","link":"Info_link__1G8YA","logo":"Info_logo__3S40e"};